export const cleanDocument = (value: string): string => {
  let document = value.replace(/\./g, "");
  document = document.replace(/-/g, "");
  document = document.replace(/\//g, "");
  return document;
};

export const onlyNumbers = (value: string): string => {
  try {
    const number = value.replace(/\D/g, "");
    return number;
  } catch (e) {
    console.log(e);
    return "";
  }
};
